import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {UsuarioPerfilController} from "./usuario/perfil";
import {UsuarioEquiposController} from "./usuario/equipos";
import {Auth} from "./firebase/auth";
import {IUsuario} from "services-comun-ed/modules/services/usuarios/interface";

export class UsuarioController {

    /* INSTANCE */
    public static instance: UsuarioController;
    private container: HTMLElement;
    private perfil: HTMLElement;
    private equipos: HTMLElement;
    private sendEmail: HTMLElement;

    /* STATIC */
    public static async build(): Promise<void> {
        UsuarioController.instance = new this();
    }

    private constructor() {
        this.perfil = document.querySelector('#mi-perfil') as HTMLElement;
        this.equipos = document.querySelector('#mis-equipos') as HTMLElement;
        this.container = document.querySelector('.principal-container') as HTMLElement;
        this.sendEmail = document.querySelector('#sendManualEmailValidationUserPage') as HTMLElement;
        this.perfil.addEventListener("click", this.initPerfil.bind(this));
        this.equipos.addEventListener("click", this.initEquipos.bind(this));
        this.initSendMailButton();
        const url = new URL(window.location.href);
        const param = url.searchParams.get("section");
        if (param === "mi-perfil") {
            UsuarioPerfilController.build();
        } else if (param === "mis-equipos") {
            UsuarioEquiposController.build();
        }
    }

    private initSendMailButton(): void {
        if (this.sendEmail) {
            this.sendEmail.addEventListener("click", async () => {
                const instance = Auth.get();
                const user = instance?.userFb;
                if (user) {
                    instance?.sendManualEmailValidation(user);
                }
            });
        }
    }

    private removeActiveTab(): void {
        this.perfil.classList.remove("activa");
        this.equipos.classList.remove("activa");
    }

    private addActiveTab(el: HTMLElement): void {
        el.classList.add("activa");
    }

    private replaceUrlParam(value: string): void {
        const urlActual: string = window.location.href;
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set("section", value);
        const nuevaCadenaDeConsulta: string = urlSearchParams.toString();
        const nuevaURL: string = urlActual.split('?')[0] + '?' + nuevaCadenaDeConsulta;
        window.history.replaceState({}, '', nuevaURL);
    }

    private async initPerfil(): Promise<void> {
        this.initSendMailButton();
        const user = Auth.get()?.userEd as IUsuario;
        if (user) {
            const perfil = await TemplatesWebFrontendRequest.perfilUsuario(user.email);
            if (this.container) {
                this.container.innerHTML = perfil.data;
                this.removeActiveTab();
                this.addActiveTab(this.perfil);
                this.replaceUrlParam("mi-perfil");
                UsuarioPerfilController.build();
            }
        }
    }

    private async initEquipos(): Promise<void> {
        this.initSendMailButton();
        const user = Auth.get()?.userEd as IUsuario;
        if (user) {
            const equipos = await TemplatesWebFrontendRequest.equiposUsuario(user.email);
            if (this.container) {
                this.container.innerHTML = equipos.data;
                this.removeActiveTab();
                this.addActiveTab(this.equipos);
                this.replaceUrlParam("mis-equipos");
                UsuarioEquiposController.build();
            }
        }
    }

}
